import { SunIcon, MoonIcon } from '@/icons'
import { useThemeStore } from '@/store/themeStore'

export function useTheme() {
  const { theme, toggleTheme } = useThemeStore()

  return {
    theme,
    toggleTheme,
    ThemeIcon: theme === 'dark' ? MoonIcon : SunIcon,
    themeLabel: theme === 'dark' ? 'Dark' : 'Light',
  }
}
